import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";
import { inputBorderRadiusMedium } from "src/styles/components/constants";

export const senecSelectTheme = (theme: SenecFPPTheme) => {
    return {
        styleOverrides: {
            icon: {
                color: theme.palette.neutralGray100.main,
            },
            select: {
                transition: "all 0.5s ease",
                "&.MuiSelect-select": {
                    transform: "translateY(8px)",
                    fontSize: 18,
                },
                "&.MuiTable-select": {
                    fontSize: 15,
                    transform: "translateY(0px)",
                    borderRadius: inputBorderRadiusMedium,
                },
                "&.MuiTablePagination-select": {
                    fontSize: 15,
                    transform: "translateY(0px)",
                    borderRadius: inputBorderRadiusMedium,
                },
            },
        },
    };
};
